import { useContext } from 'react';
import { DocumentDownloadJobContext } from './context';

export default function useDocumentDownloadJobContext() {
  return useContext(DocumentDownloadJobContext);
}
